import { Link } from "react-router-dom";

export function LegalFooter({ className = "" }: { className?: string }) {
  const sep = <span aria-hidden="true">·</span>;
  return (
    <footer className={`flex flex-wrap items-center gap-x-2 gap-y-1 text-[13px] text-[#5A6170] ${className}`} data-testid="legal-footer">
      <span>© 2026 Otium</span>{sep}
      <Link to="/terminos" className="hover:text-[#1B2A4A]" data-testid="footer-terms-link">Términos y Condiciones</Link>{sep}
      <Link to="/privacidad" className="hover:text-[#1B2A4A]" data-testid="footer-privacy-link">Aviso de Privacidad</Link>{sep}
      <a href="mailto:hola@alejandrogiron.com" className="hover:text-[#1B2A4A]" data-testid="footer-email-link">hola@alejandrogiron.com</a>
    </footer>
  );
}
